import {PureElementRule} from "../../slate/html/Html";
import {DeserializedElementRule} from "../../slate/Transformation";
import React from "react";

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "code": PureElementRule('code', {
        render: ({node}) => {
            return <pre {...node.attributes}>
                    <code>{node.children}</code>
                </pre>
        }
    })
}